<template>

    <div id="home">

        <HomeHero />

        <HomeSchedule />

        <HomeMission />

        <HomeMinistries />

        <HomeGallery />

        <HomeBlog />

        <HomeVisit />

        <HomeImpact />

        <CookieNotice />

    </div>

</template>

<script>
/* eslint-disable */

import HomeHero from './Home/Hero.vue';
import HomeSchedule from './Home/Schedule.vue';
import HomeMission from './Home/Mission.vue';
import HomeMinistries from './Home/Ministries.vue';
import HomeGallery from './Home/Gallery.vue';
import HomeBlog from './Home/Blog.vue';
import HomeVisit from './Home/Visit.vue';
import HomeImpact from './Home/Impact.vue';
import CookieNotice from '../components/cookie-notice.vue';

export default {
    name: 'Home',

    components: {
		HomeHero,
        HomeSchedule,
        HomeMission,
        HomeMinistries,
        HomeGallery,
        HomeBlog,
        HomeVisit,
        HomeVisit,
        HomeImpact,
        CookieNotice
	},

    mounted() {
        document.title = 'PIB Vallarta';

        if (window.mainUI && typeof window.mainUI === 'function')
            setTimeout(window.mainUI, 150);
    }
};
</script>